"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getOrigin(url) {
    const split = url.split("/");
    return `${split[0]}//${split[2]}`;
}
exports.default = getOrigin;
